module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAbUlEQVQ4y2NgGBTgnKDaf3LwIDKAQSPjPzrmNy38Xzdp8/+K3vX/eYzy/2NTg9eAM1ce/oeBvcdvkGYAm27O/z9//sIN+Pz1B+ku2H7oCtyApZtPkW4AyBWxZfP/R5XM/c+snYXfgOGQDoY0AACLHzVFnr5tsgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/LA.png
// module id = 1189
// module chunks = 0